import { Subscription } from 'rxjs';
import { Component, PLATFORM_ID, Inject } from '@angular/core'; import { isPlatformBrowser } from '@angular/common';
import { PdvService } from '@app/services/pdv/pdv.service';
;
@Component({
    selector: 'home',
    templateUrl: 'home.component.html',
    styleUrls: ['home.component.scss']
})
export class HomeComponent {
    isPlat = false;
    tabFam = false;
    loader = true;
    pdv: any = {};
    sub:Subscription
    constructor(@Inject(PLATFORM_ID) private platformId: Object,private pdvservice:PdvService) { }

    ngOnInit() {
        if (isPlatformBrowser(this.platformId)) {
            this.isPlat = true;
        }
        this.sub =this.pdvservice.pdv.subscribe(
            (pdv)=>{
                this.pdv = pdv;
            }
        )
    }
    changeFamMenu(action) {
        this.loader = true;
        setTimeout(
            () => {
                this.tabFam = action;
                this.loader = false;
            },1000
        )
    }
    ngOnDestroy() {
        this.sub.unsubscribe();
    }
}
